import { core, http, lookup } from 'novapay-ui';
import cloneDeep from 'lodash/cloneDeep';
import { DateTime } from 'luxon';

import commonStore from '@services/common-store';
import handleError from '@services/handle-api-error';

const { actions: commonStoreActions } = commonStore('archive-cases');

const types = core.getTypes('archive_cases');
const rootTypes = core.getTypes('root');

const getCases = async (context) => {
	let { query } = cloneDeep(context.state.props);
	let [month, year] = DateTime.local().toFormat('M-yyyy').split('-');
	if (!query.filters?.month?.length || !query.filters?.year?.length) {
		Object.assign(query.filters, {
			month: query.filters?.month || [month],
			year: query.filters?.year || [year]
		});
	}

	let [cases, schedule] = await Promise.all([http('/v3/archive/cases', { query }), http('/v3/archive/schedule')]);

	if (!handleError()(cases, context, 200)) {
		return;
	}

	context.commit(types.CASES_SUCCESS, {
		cases: cases.data,
		schedule: schedule.data,
		total: (cases.data || [])[0]?.total_count || 0
	});
	return commonStoreActions.hideRootSplashScreen(context);
};

const lookupSalepoints = (context, { query, cb }) => {
	return lookup('/v3/lookups/salepoints/code', { query: { query } }).then((res) => {
		if (!handleError()(res, context, 200)) {
			return;
		}
		cb(res.data);
	});
};
const toggleCaseModal = (context, data) => {
	if (context.state.state_key?.render?.case_modal === 'modal') {
		return context.commit(types.CLOSE_CASE_MODAL);
	}
	return context.commit(types.OPEN_CASE_MODAL, data);
};

const createCase = async (context, data) => {
	let res = await http(`/v3/archive/case`, { data, method: 'POST' });
	if (!handleError()(res, context, 200, types.VALIDATION_ERRORS)) {
		return;
	}

	context.commit(
		rootTypes.namespaced.ADD_SNACKBAR,
		{ title: 'Треба підтвердити заявку', variant: 'info' },
		{ root: true }
	);
	return context.commit(types.CREATE_CASE_SUCCESS);
};

const confirmCase = async (context, { id }) => {
	let res = await http(`/v3/archive/case/${id}/confirm`, { method: 'PUT' });
	if (!handleError()(res, context, 200, types.VALIDATION_ERRORS)) {
		return;
	}
	context.commit(
		rootTypes.namespaced.ADD_SNACKBAR,
		{ title: 'Успішно підтверджено', variant: 'success' },
		{ root: true }
	);
	return context.commit(types.CONFIRM_CASE_SUCCESS);
};

const removeCase = async (context, { id }) => {
	let res = await http(`/v3/archive/case/${id}/delete`, { method: 'PUT' });
	if (!handleError()(res, context, 200, types.VALIDATION_ERRORS)) {
		return;
	}
	context.commit(rootTypes.namespaced.ADD_SNACKBAR, { title: 'Успішно видалено', variant: 'success' }, { root: true });
	return context.commit(types.REMOVE_CASE_SUCCESS);
};

const editCase = async (context, data) => {
	let res = await http(`/v3/archive/case/${data.id}/edit`, { method: 'PUT', data });
	if (!handleError()(res, context, 200, types.VALIDATION_ERRORS)) {
		return;
	}

	context.commit(
		rootTypes.namespaced.ADD_SNACKBAR,
		{ title: 'Успішно редаговано', variant: 'success' },
		{ root: true }
	);
	return context.commit(types.EDIT_CASE_SUCCESS);
};

export default {
	...commonStoreActions,
	getCases,
	toggleCaseModal,
	createCase,
	removeCase,
	editCase,
	lookupSalepoints,
	confirmCase
};
